__webpack_require__.p = "/GinaAdhiWedding/";